import { imgPrefix } from '@/utils/imgPrefix';
import { Button } from 'darrius';
import Image from 'next/image';
import styles from '../FeedbackValidation.module.scss';
import Link from 'next/link';

export default function FeedbackValidationSuccessDocument() {
  return (
    <div className={`${styles['wrapper-feedback']}`}>
      <p className={`${styles['main-title']}`}>
        Validação de Documento Digital
      </p>

      <div className={`${styles['feedback']}`}>
        <Image
          src={imgPrefix(
            '/images/idwall/document-validation-success-document.svg'
          )}
          alt="Validação de documentos bem sucedida"
          width={164}
          height={192}
          quality={100}
        />

        <p className={`${styles['feedback-title']}`}>
          Documento validado com sucesso!
        </p>

        <span>
          Você agora é um ninja verificado. Que tal aproveitar para conferir
          nossos pacotes de moedas?
        </span>

        <Link href={'https://www.getninjas.com.br/instale'}>
          <Button.Root
            type="button"
            variation="primary"
            className={`${styles['feedback-button']}`}
          >
            Fazer download do aplicativo
          </Button.Root>
        </Link>
      </div>
    </div>
  );
}
